import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import heroBg from "../assets/images/bg.jpg";


// Existing Components
import OurServices from "../components/OurServices";
import FeatureHighlights from "../components/FeatureHighlights";
import MockupBox from "../components/AnimatedOverlay";

// Custom styles for the dark theme based on previous analysis
const customStyles = {
    neonGradientText: {
        background: "linear-gradient(90deg, #00F5A0, #00CFFF)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
    },
    ctaGradient: {
        background: "linear-gradient(to right, #FF2D55, #FF005C)",
    },
    ctaGradientText: {
        background: "linear-gradient(to right, #00F5A0, #00F5A0)", 
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
    },
    O_Gradient: {
        background: "linear-gradient(to right, #FFFFFF 20%, #00F5A0 50%, #00F5A0 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
    },
    Se_Gradient: {
        background: "linear-gradient(to right, #FFFFFF 0%, #00CFFF 50%, #00F5A0 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
    },
    s_end_Gradient: {
        background: "linear-gradient(to right, #FFFFFF 20%, #00F5A0 50%, #00F5A0 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
    },
};


export default function Home() {
    return (
        <div className="min-h-screen bg-[#0B0E11] text-white flex flex-col">
            <Navbar />

            {/* ================= 1. HERO SECTION ================= */}
            <section
                className="relative flex flex-col items-center justify-center min-h-[90vh] text-center px-4 sm:px-6 md:px-10 lg:px-20 py-20 overflow-hidden"
                style={{ backgroundColor: '#0B0E11' }}
            >
                {/* HERO Background Image */}
                <div
                    className="absolute inset-0 z-0"
                    style={{
                        backgroundImage: `url(${heroBg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        opacity: 0.20,
                    }}
                ></div>

                <div className="absolute inset-0 z-0 opacity-20">
                    <div className="absolute w-full h-full" style={{
                        background: 'radial-gradient(circle at 50% 100%, #00CFFF1A, transparent 50%)'
                    }}></div>
                </div>

                {/* Content */}
                <div className="relative z-10 max-w-4xl mx-auto space-y-8">
                    <p className="text-xl text-white/70 font-medium tracking-wider uppercase">
                        The Tech Presents,
                    </p>

                    <h1 className="text-4xl sm:text-6xl md:text-7xl font-extrabold leading-tight text-white">
                        The Craft
                        <span
                            className="bg-clip-text text-transparent inline-block"
                            style={{
                                backgroundImage: `
                                    linear-gradient(to bottom, #ffffff 20%,transparent 65%),
                                    linear-gradient(to right, #00F5A0, #00CFFF)
                                `,
                            }}
                        >
                            T
                        </span>
                        ech
                    </h1>

                    <p className="text-white/70 max-w-2xl mx-auto text-lg pt-4">
                        We <b>design, built and scale </b>High-performance digital products for startup and enterprises worldwide.
                    </p>

                    {/* CTA BUTTONS - Responsive logic added here */}
                    <div className="flex flex-col md:flex-row gap-4 md:gap-6 justify-center pt-6 items-center">
                        <button className="w-full md:w-auto px-8 py-3 rounded-full font-semibold text-black hover:scale-[1.02] transition"
                            style={{ background: 'linear-gradient(90deg, #00F5A0, #00CFFF)' }}
                        >
                            Start a Project →
                        </button>

                        <button className="w-full md:w-auto px-8 py-3 rounded-full font-semibold border border-white/40 hover:bg-white/10 transition">
                            Call Now →
                        </button>
                    </div>
                </div>
            </section>

            {/* ================= 2. ABOUT/INSIGHTS SECTION ================= */}
            <section className="px-4 sm:px-6 md:px-10 lg:px-20 py-24 space-y-16 bg-[#121518]">
                <div className="max-w-5xl">
                    <h3 className="text-3xl md:text-4xl font-extrabold mb-4">
                        <span className="text-white">About</span>{" "}
                        <span style={customStyles.ctaGradientText}>Craft</span>{" "}
                        <span style={customStyles.neonGradientText}>Tech</span>
                    </h3>

                    <p className="text-white/70 leading-relaxed max-w-xl">
                        Craft Tech is a modern technology company focused on building scalable digital systems,
                        creative solutions and high-impact software products for global businesses.
                    </p>
                </div>
                <FeatureHighlights />
            </section>

            {/* ================= 3. OUR SERVICES SECTION ================= */}
            <section className="px-4 sm:px-6 md:px-10 lg:px-20 py-24 space-y-16">
                <div className="text-center">
                    <h2 className="text-6xl sm:text-7xl md:text-8xl font-extrabold leading-none tracking-tight">
                        <span style={customStyles.O_Gradient}>O</span>
                        <span className="text-white">u</span>
                        <span className="text-white">r</span>
                        <span> </span>
                        <span style={customStyles.Se_Gradient}>S</span>
                        <span style={customStyles.Se_Gradient}>e</span>
                        <span className="text-white">r</span>
                        <span className="text-white">v</span>
                        <span className="text-white">i</span>
                        <span style={customStyles.Se_Gradient}>c</span>
                        <span style={customStyles.s_end_Gradient}>e</span>
                        <span style={customStyles.s_end_Gradient}>s</span>
                    </h2>
                    <p className="text-white/70 mt-3 text-lg">See how we can help your business grow.</p>
                </div>
                <OurServices />
            </section>

            <Footer />
        </div>
    );
}